import { Tag } from "antd";
import { PureComponent } from "react";

import { type IBTGridExpanableCellProps } from "commonComponents/utilities/Grid/common/BTGridExpandableCell";
import { type IGridCellRenderProps } from "commonComponents/utilities/Grid/Grid.types";
import { getButtonSizeFromGridSize } from "commonComponents/utilities/Grid/Grid.utilities";
import {
    GridColumnType,
    type IClientGridColumn,
} from "commonComponents/utilities/Grid/GridContainer.types";
import ReadMorePresentational from "commonComponents/utilities/ReadMore/ReadMorePresentational";

type ITagResponse = { tagId: number; tagTitle: string }[];

class TagsCell extends PureComponent<
    IGridCellRenderProps<ITagResponse> & IBTGridExpanableCellProps
> {
    render() {
        const { cellValue, isColumnExpanded, size, onExpandToggle, ...restProps } = this.props;
        if (!cellValue) {
            return null;
        }
        return (
            <ReadMorePresentational
                lineHeight={1.9}
                numberOfLines={2}
                showingMore={isColumnExpanded}
                size={getButtonSizeFromGridSize(size)}
                onShowingMoreToggle={onExpandToggle}
                {...restProps}
            >
                {cellValue.map(
                    (x) => (
                        <Tag key={x.tagId} style={{ background: "unset", margin: "2px" }}>
                            {x.tagTitle}
                        </Tag>
                    ), // without unsetting the background, the show more component will make the text disappear
                )}
            </ReadMorePresentational>
        );
    }
}

export const columnTags: IClientGridColumn<ITagResponse> = {
    columnType: GridColumnType.tags,
    Cell: TagsCell,
    isExpandable: "insideCell",
};
